"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _icons = require("@material-ui/icons");
var _core = require("@material-ui/core");
var _CardMenu = require("./CardMenu");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProductCard = _ref => {
  let {
    children,
    list,
    cardClass,
    image,
    imageTitle,
    imageHoverText,
    imageClass,
    onMediaClick,
    contentClass,
    showFavorite,
    isFavorite,
    favoriteLocation,
    favoritePosition,
    onFavorite,
    favoriteIconActive,
    favoriteIconDisabled,
    iconButtonClass,
    showPopoverMenu,
    menuIcon,
    menuItems,
    menuAnchorEl,
    menuHandlerClick,
    menuHandlerClose,
    menuIconPosition,
    flag,
    flagPosition
  } = _ref;
  const [hover, setHover] = (0, _react.useState)(false);
  const defaultCardClasses = (0, _styles.useCardStyles)({
    list
  });
  const defaultMediaClasses = (0, _styles.useMediaStyles)();
  const wrapperClasses = (0, _styles.useWrapperStyles)();
  const defaultContentClasses = (0, _styles.useContentStyles)({
    list
  });
  const actionAreaClasses = (0, _styles.useActionAreaStyle)({
    list
  });
  const defaultIconButtonClasses = (0, _styles.useIconButtonStyles)({
    favoritePosition
  });
  const flagClasses = (0, _styles.useFlagStyles)({
    flagPosition
  });
  const hoverTextClasses = (0, _styles.useHoverTextStyle)();
  const cardStyles = cardClass ? (0, _clsx.default)(defaultCardClasses.root, cardClass.root) : defaultCardClasses.root;
  const mediaStyles = imageClass ? (0, _clsx.default)(defaultMediaClasses.root, imageClass.root) : defaultMediaClasses.root;
  const wrapperStyles = list ? (0, _clsx.default)(wrapperClasses.root, wrapperClasses.list) : (0, _clsx.default)(wrapperClasses.root, wrapperClasses.gallery);
  const contentStyles = contentClass ? (0, _clsx.default)(defaultContentClasses.root, contentClass.root) : defaultContentClasses.root;
  const iconButtonStyles = iconButtonClass ? (0, _clsx.default)(defaultIconButtonClasses.root, iconButtonClass.root) : defaultIconButtonClasses.root;
  const cardListStyle = {
    height: 'auto',
    maxWidth: '100%'
  };
  const cardMediaListStyle = {
    height: 'auto'
  };
  const contentListStyle = {
    margin: 0
  };
  const showFavoriteInImage = () => {
    if (showFavorite && favoriteLocation === 'image') {
      return true;
    }
    return false;
  };
  const showFavoriteInWrapper = () => {
    if (showFavorite && favoriteLocation === 'wrapper') {
      return true;
    }
    return false;
  };
  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: cardStyles,
    style: list ? cardListStyle : {}
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: wrapperStyles
  }, /*#__PURE__*/_react.default.createElement(_core.CardActionArea, {
    className: actionAreaClasses.root
  }, /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    component: "img",
    alt: imageTitle,
    title: imageTitle,
    className: mediaStyles,
    image: image,
    style: list ? cardMediaListStyle : {},
    onMouseOver: () => setHover(true),
    onMouseLeave: () => setHover(false),
    onClick: onMediaClick
  }), showFavoriteInImage() && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onFavorite,
    className: iconButtonStyles,
    "aria-label": isFavorite ? 'Desfavoritar Livro' : 'Favoritar Livro'
  }, isFavorite ? favoriteIconActive : favoriteIconDisabled), flag && /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: flagClasses.root
  }, flag), hover && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    className: hoverTextClasses.root
  }, imageHoverText)), /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: contentStyles,
    style: list ? contentListStyle : {}
  }, children), showFavoriteInWrapper() && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onFavorite,
    className: iconButtonStyles
  }, isFavorite ? favoriteIconActive : favoriteIconDisabled), showPopoverMenu && /*#__PURE__*/_react.default.createElement(_CardMenu.CardMenu, {
    menuIcon: menuIcon,
    menuItems: menuItems,
    menuAnchorEl: menuAnchorEl,
    menuHandlerClick: menuHandlerClick,
    menuHandlerClose: menuHandlerClose,
    menuIconPosition: menuIconPosition
  })));
};
exports.ProductCard = ProductCard;
ProductCard.propTypes = {
  // Componentes do conteúdo do card
  children: _propTypes.default.node,
  // Define o formato do Card: Galeria (vertical) ou Lista (horizontal)
  list: _propTypes.default.bool,
  // Objeto com classe "root" para estilização da imagem
  cardClass: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),
  // URL da Imagem do Card
  image: _propTypes.default.string.isRequired,
  // Texto alternativo e titulo da imagem do Card
  imageTitle: _propTypes.default.string,
  // Texto do hover da imagem do Card
  imageHoverText: _propTypes.default.string,
  // Objeto com classe "root" para estilização da imagem
  imageClass: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),
  // Função acionada ao clicar na imagem do Card
  onMediaClick: _propTypes.default.func,
  // Objeto com classe "root" para estilização da Wrapper de conteúdo
  contentClass: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),
  // Define se será exibido o botão de favoritar
  showFavorite: _propTypes.default.bool,
  // Estado que representa se o item é favorito ou não
  isFavorite: _propTypes.default.bool,
  // Define onde o botão de Favorito será renderizado, junto ao container da imagem, ou ao container do card.
  favoriteLocation: _propTypes.default.oneOf(['image', 'wrapper']),
  // Caso o favoriteLocation seja "image", define a direção que o icone de favoritos será renderizado.
  favoritePosition: _propTypes.default.oneOf(['bottomLeft', 'bottomRight', 'topLeft', 'topRight']),
  // Icone do botão de favoritar ativo
  favoriteIconActive: _propTypes.default.node,
  // Icone do botão de favoritar desativado
  favoriteIconDisabled: _propTypes.default.node,
  // Função de callbcak do click do botão de favoritar
  onFavorite: _propTypes.default.func,
  // Objeto com classe "root" para estilização da botão do ícone de favoritar
  iconButtonClass: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),
  // Define se será exibido o botão com menu de opções em Popover
  showPopoverMenu: _propTypes.default.bool,
  // Icone do botão do menu Popover
  menuIcon: _propTypes.default.node,
  // Posicionamento do icone do menu
  menuIconPosition: _propTypes.default.oneOf(['left', 'right']),
  // Elemento HTML que define a posição do menu Popover
  menuAnchorEl: _propTypes.default.node,
  // Lista com dados dos item do menu Popover
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    click: _propTypes.default.func
  })),
  // Função responsável por abrir o menu Popover
  menuHandlerClick: _propTypes.default.func,
  // Função responsável por fechar o menu Popover
  menuHandlerClose: _propTypes.default.func,
  // Componente de flag com informação adicional para o Card
  flag: _propTypes.default.node,
  // Define a direção que o icone de favoritos será renderizado na imagem
  flagPosition: _propTypes.default.oneOf(['bottomLeft', 'bottomRight', 'topLeft', 'topRight'])
};
ProductCard.defaultProps = {
  children: null,
  list: false,
  cardClass: null,
  imageTitle: '',
  imageClass: null,
  imageHoverText: 'Detalhes',
  onMediaClick: () => {},
  contentClass: null,
  showFavorite: false,
  isFavorite: false,
  favoriteLocation: 'image',
  favoritePosition: 'bottomLeft',
  onFavorite: () => {},
  favoriteIconActive: _propTypes.default.instanceOf(/*#__PURE__*/_react.default.createElement(_icons.Favorite, null)),
  favoriteIconDisabled: _propTypes.default.instanceOf(/*#__PURE__*/_react.default.createElement(_icons.FavoriteBorder, null)),
  iconButtonClass: null,
  showPopoverMenu: false,
  menuIcon: _propTypes.default.instanceOf(/*#__PURE__*/_react.default.createElement(_icons.MoreVert, null)),
  menuIconPosition: 'right',
  menuAnchorEl: null,
  menuItems: null,
  menuHandlerClick: () => {},
  menuHandlerClose: () => {},
  flag: null,
  flagPosition: 'bottomRight'
};